import { RootState } from "./store";

export const autoSelect = (state: RootState) => state;
